/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PopupboxManager, PopupboxContainer } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function Aboutus() {
const { t } = useTranslation();

// Responsive styles
const responsiveStyles = `
.row {
display: flex !important;
flex-wrap: wrap !important;
}
.col-lg-6:first-child {
order: -1 !important;
}
@media (max-width: 992px) {
.about-one__image {
max-width: 100% !important;
margin: 0 auto 30px auto !important;
}
.col-lg-6:first-child {
order: -1 !important;
margin-bottom: 30px !important;
}
}
@media (max-width: 768px) {
.about-responsive-container {
padding: 30px !important;
}
.about-responsive-content {

}
.about-responsive-box {
padding: 20px 15px !important;
margin-bottom: 20px !important;
}
.about-responsive-title {
font-size: 32px !important;
margin-bottom: 20px !important;
}
.about-responsive-text {
font-size: 16px !important;
margin-bottom: 20px !important;
line-height: 1.6 !important;
}
.about-one__image {
min-height: 350px !important;
margin-bottom: 30px !important;
}
.about-one__image img {
min-height: 350px !important;
}

.col-lg-6:last-child {
padding: 20px !important;
}
.row {
margin: 0 !important;
padding: 20px 0 !important;
}
}
@media (max-width: 576px) {
.about-responsive-container {
padding: 20px !important;
}
.about-responsive-content {
}
.about-responsive-box {
padding: 20px !important;
margin-bottom: 15px !important;
}
.about-responsive-title {
font-size: 28px !important;
margin-bottom: 15px !important;
}
.about-responsive-text {
font-size: 15px !important;
margin-bottom: 15px !important;
line-height: 1.5 !important;
}
.about-one__image {
min-height: 300px !important;
margin-bottom: 20px !important;
padding: 0 5px !important;
}
.about-one__image img {
min-height: 300px !important;
}

.col-lg-6:last-child {
padding: 10px 5px !important;
}
.row {
margin: 0 !important;
padding: 20px 0 !important;
}
}
`;

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const openVideoPopup = () => {
const content = (
<div>
  <iframe width="100%" height="250" src="https://www.youtube.com/embed/Ft1jRmswJ_s" title="Video" frameBorder="0"
    allowFullScreen></iframe>
</div>
);

PopupboxManager.open({ content });
};

const popupboxConfig = {
fadeIn: true,
fadeInSpeed: 500,
};

return (
<section className="about-one section-space-top" id="about">
  <style dangerouslySetInnerHTML={{ __html: responsiveStyles }} />
  <div className="container about-responsive-container" style={{ 
        maxWidth: '1200px', 
        padding: '30px',
        margin: '0 auto'
      }}>

        <div className="row">
          <div className="col-lg-6 wow fadeInRight p-0" data-wow-duration="1500ms">
            <div className="about-one__content about-responsive-content" style={{ 
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '20px',
              maxWidth: '100%',
              overflow: 'hidden',
              marginLeft: '0',
              marginRight: '0'
            }}>
              <div className="sec-title" style={{ marginBottom: '30px' }}>
                <img
                  src="assets/images/favicons/favicon-32x32.webp"
                  alt="Seymen Kimya Logo"
                  className="sec-title__img"
                />

                <h6 className="sec-title__tagline" style={{ 
                  fontSize: '16px', 
                  fontWeight: '600',
                  color: '#10adad',
                  marginBottom: '10px'
                }}>Seymen Kimya</h6>

                <h2 className="sec-title__title about-responsive-title" style={{ 
                  fontSize: '42px', 
                  fontWeight: '700',
                  marginBottom: '25px',
                  textTransform: 'capitalize'
                }}>Hakkımızda</h2>
              </div>
              <p className="about-one__text about-responsive-text" style={{ 
                fontSize: '16px', 
                lineHeight: '1.8',
                color: '#666',
                marginBottom: '25px',
                textAlign: 'justify'
              }}>
                <strong style={{ 
                  color: '#10adad'}}>Seymen Kimya San. Tic. Ltd. Şti.</strong> olarak, <strong>2007 yılında</strong> kimya sektöründeki yolculuğumuza başladık. Kurulduğumuz günden bu yana, sürekli gelişim ve kalite odaklı üretim anlayışımızla sektörün güvenilir ve saygın firmalarından biri olma hedefiyle ilerledik.
              </p>

              <h5 style={{ 
                  color: '#10adad', 
                  fontSize: '18px', 
                  fontWeight: '600', 
                  marginBottom: '15px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  📈 Büyüme ve Gelişim Hikayemiz
                </h5>

              <p style={{ 
                  fontSize: '16px', 
                  lineHeight: '1.7', 
                  color: '#555', 
                  margin: 0,
                  textAlign: 'justify'
                }}>
                  İlk adımlarımızı attığımız 2007 yılında, sadece <strong>200 m²</strong> gibi mütevazı bir alanda faaliyet gösterirken, bugün ulaştığımız noktada kat ettiğimiz ilerleme, vizyonumuzun ve azmimizin bir göstergesidir.
                  <br /><br />
                  2020 yılında yeni ve modern tesisimize taşınmanın gururunu yaşadık. Yeni yerimizde toplam <strong>600 m² kapalı alan ve 300 m² açık alan</strong> ile daha geniş, daha teknolojik ve daha verimli bir üretim kapasitesine ulaştık.
                </p>
            </div>
          </div>

          <div className="col-lg-6 wow fadeInRight" data-wow-duration="1500ms">
            <div className="about-three__image">
              <img src="assets/images/about/about.webp" alt="Hakkimizda" className="about-three__image__one" />
            </div>
                  
          </div>            
        </div>

        <div className="about-one__content about-responsive-content" >

                <h5 style={{ 
                  color: '#10adad', 
                  fontSize: '18px', 
                  fontWeight: '600', 
                  marginBottom: '15px',
                  display: 'flex',
                  padding: '0 15px',
                  alignItems: 'center'
                }}>
                  ✨ Misyonumuz ve Vizyonumuz
                </h5>

                 <p style={{ 
                  fontSize: '16px', 
                  lineHeight: '1.7', 
                  color: '#555', 
                  margin: 0,
                  padding: '0 15px',
                  textAlign: 'justify'
                }}>
                  <strong>Misyonumuz:</strong> Kaliteli hammadde ve ileri teknoloji kullanarak, uluslararası standartlarda, çevreye duyarlı ve kullanıcı sağlığını ön planda tutan temizlik ve kimyasal ürünler üretmektir.
                  <br /><br />
                  <strong>Vizyonumuz:</strong> Yenilikçi çözümlerimizle sektörde öncü bir rol üstlenmek, yerel ve küresel pazarda tercih edilen bir marka olmak ve sürdürülebilir büyüme ile ülke ekonomisine değer katmaktır.
                </p>
              <br/>
              <div className="about-one__inner" style={{ marginBottom: '30px' }}>
                <h5 className="about-one__info-title" style={{ 
                  fontSize: '20px', 
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '20px',
                  padding: '0 15px'
                }}>
                  Kimya Sektöründe Güvenilir Çözüm Ortağınız
                </h5>
                <ul className="about-one__info" style={{ 
                  listStyle: 'none', 
                  padding: '0 15px',
                  margin: 0
                }}>
                  <li style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '3px',
                    padding: '16px 16px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}>
                    <span className="icon-check-mark" style={{ 
                      color: '#10adad', 
                      fontSize: '16px',
                      marginRight: '10px',
                      flexShrink: 0
                    }}></span>
                    <span style={{ fontSize: '15px', color: '#555' }}>Uluslararası Standartlarda Üretim</span>
                  </li>
                  <li style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '3px',
                    padding: '16px 16px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}>
                    <span className="icon-check-mark" style={{ 
                      color: '#10adad', 
                      fontSize: '16px',
                      marginRight: '10px',
                      flexShrink: 0
                    }}></span>
                    <span style={{ fontSize: '15px', color: '#555' }}>Çevreye Duyarlı Ürünler</span>
                  </li>
                  <li style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '12px',
                    padding: '16px 16px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}>
                    <span className="icon-check-mark" style={{ 
                      color: '#10adad', 
                      fontSize: '16px',
                      marginRight: '10px',
                      flexShrink: 0
                    }}></span>
                    <span style={{ fontSize: '15px', color: '#555' }}>Modern Teknoloji ve Kalite</span>
                  </li>
                </ul>
              </div>
              <div className="about-one__bottom p-3">

                <a href="/urunlerimiz" className="boskery-btn">
                  <span className="boskery-btn__hover"></span>
                  <span className="boskery-btn__hover"></span>
                  <span className="boskery-btn__hover"></span>
                  <span className="boskery-btn__hover"></span>
                  <span className="boskery-btn__hover"></span>
                  <span className="boskery-btn__hover"></span>
                  <span className="boskery-btn__text">
                    Ürünlerimizi Keşfedin
                  </span>
                </a>
                <div className="contact__info">
                  <div className="contact__info__inner">
                    <div className="contact__info__icon">
                      <span className="icon-telephone"></span>
                    </div>
                    <div className="contact__info__right">
                      <h4 className="contact__info__title">
                        BİLGİ VE SİPARİŞ İÇİN
                      </h4>
                      <a
                        href="tel:+905553735627"
                        className="contact__info__number"
                      >
                        (0555) 373 56 27
                      </a>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div>

      <PopupboxContainer {...popupboxConfig} />
    </section>
  );
}

export default Aboutus;
